import {
  Typography,
  Select,
  Option,
  Chip,
  Button,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Input,
  Tooltip,
  IconButton,
} from "@material-tailwind/react";
import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { FaCheckDouble, FaLock, FaUnlock, FaTrashAlt } from "react-icons/fa";
import { GiCycle } from "react-icons/gi";
import EditMetaContent from "../EditMetaContent";
// import GenerateSummayQA from '../GenerateSummayQA';
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import RequestAppeal from "../RequestAppeal";
import ViewLogsDoc from "../ViewLogsDoc";
import { setSessionExpired, useMainController } from "../../../../context";
import { toast } from "react-toastify";
import UserService from "../../../../KeyCloackServices/UserService";
import DocsStatus from "../../My Reseach/DocsStatus";
import Table from "../../../../widgets/table";
import http, { httpPostProcessing } from "../../../../services/http-common";
import { saveMetaData } from "../../../../store/dataFlow/actions";
import { useDispatch } from "react-redux";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import { debounce } from "lodash";
// import ContributeDocs from 'pages/SubmitResearch/ContributeDocs';

const AllScientificDocs = () => {
  const [dispatchHttp] = useMainController();
  const [openMenu, setOpenMenu] = useState(false);
  const [contentId, setContentId] = useState(null);
  const [editorOpen, setEditorOpen] = useState(false);
  const [logsOpen, setLogsOpen] = useState(false);
  const [appealOpen, setAppealOpen] = useState(false);
  // const [viewOpen, setViewOpen] = useState(false);
  const queryClient = useQueryClient();

  const cp = queryClient.getQueryData("books-cp");
  const ps = queryClient.getQueryData("books-ps");
  const filters = queryClient.getQueryData("books-filters");
  const sorters = queryClient.getQueryData("books-sorters");

  const { register, handleSubmit } = useForm({
    mode: "onSubmit",
  });
  const [books, setBooks] = useState([]);
  const dispatch = useDispatch();
  const [selectedDocsApi, setSelectedDocsApi] = useState("all");
  const [filterValue, setFilterValue] = useState("");

  const [checkValues, setCheckValues] = useState([]);
  const [currentPage, setCurrentPage] = useState(cp || 1);
  const [pageSize, setPageSize] = useState(ps || 50);
  const [totalPage, setTotalPage] = useState(10000);
  const [filterValues, setFilterValues] = useState(filters || {});
  const [sorterValues, setSorterValues] = useState(
    sorters || { updated_at: { desc: true } }
  );
  const [selectedFilter, setSelectedFilter] = useState("name");

  useQuery("books-cp", () => currentPage);
  useQuery("books-ps", () => pageSize);
  useQuery("books-filters", () => filterValues);
  useQuery("books-sorters", () => sorterValues);

  const errorFunc = (error) => {
    let message;
    message = error.response.data.message || error.message;
    toast.error(message);
  };

  const { isError, data, refetch, isFetching } = useQuery(
    ["books", currentPage, pageSize, filterValues, sorterValues],
    () => {
      if (filterValue.length > 0) {
        return httpPostProcessing.post(
          `train/book/search`,
          {
            cp: currentPage,
            ps: pageSize,
            filters: {
              [selectedFilter]: filterValue,
            },
          },
          setSessionExpired,
          dispatchHttp
        );
      } else {
        return httpPostProcessing.get(
          `/train/${
            selectedDocsApi === "all"
              ? UserService.getRole()?.roles?.includes("admin")
                ? "book/all"
                : "book/"
              : "book/mine"
          }/?cp=${currentPage}&ps=${pageSize}${
            JSON.stringify(filterValues) !== "{}"
              ? `&filters=${JSON.stringify(filterValues)}`
              : ""
          }${
            JSON.stringify(sorterValues) !== "{}"
              ? `&sorters=${JSON.stringify(sorterValues)}`
              : ""
          }`,
          null,
          setSessionExpired,
          dispatchHttp
        );
      }
    },
    {
      keepPreviousData: true,
      refetchInterval: 5000,
      queryKey: ["books", currentPage, pageSize], // Unique key for the query
      staleTime: 30000, // Keep data in cache for 30 seconds
      retryOnMount: true,
    }
  );

  useEffect(() => {
    if (isError) {
      toast.error("Fetch data failed");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  useEffect(() => {
    if (data && data.data) {
      const { docs, pageSize, total } = data.data;
      const newDocs = docs.map((doc) => {
        return {
          ...doc,
          key: doc.id,
          name: (
            <Tooltip
              content={doc.name}
              animate={{
                mount: { scale: 1, y: 0 },
                unmount: { scale: 0, y: 25 },
              }}
            >
              <Typography
                variant="small"
                color="blue-gray"
                className="font-semibold"
                onClick={() => {
                  handleWebEditMetaData(doc.docType, doc.id);
                }}
              >
                {doc.name?.length > 40
                  ? doc.name.slice(0, 40) + "..."
                  : doc.name}
              </Typography>
            </Tooltip>
          ),
          uploadedBy: (
            <Typography
              variant="small"
              color="blue-gray"
              className="font-semibold"
            >
              {doc?.uploadedBy ? doc?.uploadedBy : "N/A"}
            </Typography>
          ),
          status: (
            <div className="flex !w-full">
              <Chip
                icon={
                  (doc.status === "rejected" ||
                    doc.status === "training failed") && (
                    <Tooltip
                      content={doc?.rejectionReason}
                      animate={{
                        mount: { scale: 1, y: 0 },
                        unmount: { scale: 0, y: 25 },
                      }}
                    >
                      <ExclamationCircleIcon className="bg-[white] rounded-full text-[black] m-[1px]" />
                    </Tooltip>
                  )
                }
                variant="gradient"
                color={status(doc.status)}
                value={doc.status}
                className="py-0.5 w-full px-2 text-[11px] font-medium"
              />
            </div>
          ),
          private: (
            <Chip
              variant="gradient"
              color={doc.private ? "red" : "blue"}
              value={doc.private ? "private" : "public"}
              className="py-0.5 px-2 text-[11px] font-medium"
            />
          ),
          actions: (
            <>
              {UserService.getRole()?.roles?.includes("admin") && (
                <Menu
                  animate={{
                    mount: { y: 0 },
                    unmount: { y: 25 },
                  }}
                >
                  <MenuHandler>
                    <Button>Action</Button>
                  </MenuHandler>
                  <MenuList>
                    <MenuItem
                      onClick={() => {
                        handleForceTrain(doc.id);
                      }}
                    >
                      Force Train
                    </MenuItem>
                    <Menu
                      placement="right-start"
                      open={openMenu}
                      handler={setOpenMenu}
                      allowHover
                      offset={15}
                    >
                      <MenuHandler className="flex items-center justify-between">
                        <MenuItem>
                          Move
                          <ChevronUpIcon
                            strokeWidth={2.5}
                            className={`h-3.5 w-3.5 transition-transform ${
                              openMenu ? "rotate-90" : ""
                            }`}
                          />
                        </MenuItem>
                      </MenuHandler>
                      <MenuList>
                        <MenuItem
                          onClick={() => {
                            handleMove(doc.id, "law");
                          }}
                        >
                          Law Docs
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleMove(doc.id, "wisdom");
                          }}
                        >
                          Wisdom Docs
                        </MenuItem>
                      </MenuList>
                    </Menu>
                    {doc.docType === "web" ? (
                      <MenuItem
                        onClick={() => {
                          deleteWebFunc(doc.id);
                        }}
                      >
                        Delete
                      </MenuItem>
                    ) : (
                      <MenuItem
                        onClick={() => {
                          deleteFunc(doc.id);
                        }}
                      >
                        Delete
                      </MenuItem>
                    )}
                  </MenuList>
                </Menu>
              )}
            </>
          ),
        };
      });
      setBooks(newDocs);

      setTotalPage(Math.ceil(total / pageSize));
    }
  }, [data]);

  const handleWebEditMetaData = (docType, id) => {
    if (docType === "web") {
      getWebDetails.mutate(id);
    } else {
      getScienceDocDetails.mutate(id);
    }
  };
  const getScienceDocDetails = useMutation(
    (docId) => {
      return httpPostProcessing.post(`train/book/find-by-id`, { id: docId });
    },
    {
      onSuccess: ({ data }) => {
        dispatch(saveMetaData(data.doc));
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );

  const getWebDetails = useMutation(
    (webId) => {
      return httpPostProcessing.post(`train/website/findById`, { id: webId });
    },
    {
      onSuccess: ({ data }) => {
        dispatch(saveMetaData(data.website));
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );

  const startMoveTrain = useMutation(
    (data) => {
      return httpPostProcessing.post(
        `train/book/move-doc-to-other-db`,
        {
          docId: data.val.id,
          type: data.val.type, //Science,Law,Wisdom,Temp
          docType: data.val.docType, //web,
          moveTo: {
            db: data.moveTo, //Science,Law,Wisdom,
          },
        },
        null,
        setSessionExpired,
        dispatchHttp
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );

  const startTrain = useMutation(
    (val) => {
      return httpPostProcessing.post(
        `train/book/move-doc-to-other-db`,
        {
          docId: val.id,
          type: val.type, //Science,Law,Wisdom,Temp
          docType: val.docType, //web,
        },
        null,
        setSessionExpired,
        dispatchHttp
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );
  const startUnTrain = useMutation(
    (docId) => {
      return httpPostProcessing.deleteDocFrompinecone(
        `train/book/delete-from-pinecone`,
        {
          id: docId,
        }
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );

  const handleForceTrain = (id) => {
    const val = data.data.docs.find((book) => book.id === id);
    startTrain.mutate(val);
  };
  const handleMove = (id, moveTo) => {
    const val = data.data.docs.find((book) => book.id === id);
    startMoveTrain.mutate({ val, moveTo });
  };

  const handleUnTrain = (id) => {
    startUnTrain.mutate(id);
  };

  const changePrivate = useMutation(
    (val) => {
      return httpPostProcessing.put(
        `train/book/${val.id}/private`,
        { private: val.private === true ? "public" : "private" },
        null
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );

  const updatePrivate = (id) => {
    const val = data.data.docs.find((book) => book.id === id);
    changePrivate.mutate(val);
  };
  const deleteData = useMutation(
    (id) => {
      return httpPostProcessing.post(
        `train/book/bulk/delete`,
        { ids: [id] },
        null,
        setSessionExpired,
        dispatchHttp
      );
    },
    {
      onSuccess: () => {
        toast.success("Successfully Deleted");
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );
  const deleteWebData = useMutation(
    (id) => {
      return httpPostProcessing.post(
        `train/website/bulk/delete`,
        { ids: [id] },
        null,
        setSessionExpired,
        dispatchHttp
      );
    },
    {
      onSuccess: () => {
        toast.success("Successfully Deleted");
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );

  const deleteFunc = (id) => {
    deleteData.mutate(id);
  };
  const deleteWebFunc = (id) => {
    deleteWebData.mutate(id);
  };

  const status = (value) => {
    switch (value) {
      case "ready": {
        return "blue";
      }
      case "rejected": {
        return "red";
      }
      case "scraping": {
        return "purple";
      }
      case "scraping failed": {
        return "red";
      }
      case "scraped": {
        return "cyan";
      }
      case "traning": {
        return "teal";
      }
      case "training failed": {
        return "pink";
      }
      case "trained": {
        return "green";
      }
      default: {
      }
    }
  };

  // const bulkGenerateMetaDataRequest = useMutation(
  //   () => {
  //     return httpForEntheoGpt.post('llms/generate-metadata', { ids: checkValues }, null, setSessionExpired, dispatchHttp);
  //   },
  //   {
  //     onSuccess: ({ data }) => {
  //       toast.success(data.message);
  //       setCheckValues([]);
  //     },
  //     onError: error => {
  //       errorFunc(error);
  //     },
  //   }
  // );

  // const bulkGenerateMetaData = () => {
  //   bulkGenerateMetaDataRequest.mutate();
  // };

  const bulkTrainRequest = useMutation(
    () => {
      return httpPostProcessing.post(
        "train/book/bulk/train",
        { ids: checkValues },
        null,
        setSessionExpired,
        dispatchHttp
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
        setCheckValues([]);
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );
  const bulkTrain = () => {
    bulkTrainRequest.mutate();
  };

  const bulkPrivateRequest = useMutation(
    (val) => {
      return httpPostProcessing.put(
        "train/book/bulk/private",
        { private: val, ids: checkValues },
        null
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
        setCheckValues([]);
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );
  const bulkPrivate = () => {
    bulkPrivateRequest.mutate("private");
  };
  const bulkPublic = () => {
    bulkPrivateRequest.mutate("public");
  };
  const bulkDeleteRequst = useMutation(
    () => {
      let arrCheckedValues = checkValues.map(Number);
      return httpPostProcessing.post(
        `train/book/${
          selectedDocsApi === "all" ? "bulk/delete" : "mine/bulk/delete"
        }`,
        { ids: arrCheckedValues },
        null,
        setSessionExpired,
        dispatchHttp
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
        setCheckValues([]);
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );
  const bulkDelete = () => {
    bulkDeleteRequst.mutate();
  };
  const bulkReAttemptRequst = useMutation(
    () => {
      let arrCheckedValues = checkValues.map(Number);
      return httpPostProcessing.post(
        `/train/book/re-attempt`,
        { ids: arrCheckedValues },
        null,
        setSessionExpired,
        dispatchHttp
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
        setCheckValues([]);
      },
      onError: (error) => {
        errorFunc(error);
      },
    }
  );
  const bulkReAttempt = () => {
    bulkReAttemptRequst.mutate();
  };

  const actions = (
    <>
      {UserService.getRole()?.roles?.includes("admin") ? (
        <>
          <Tooltip content="Reprocess">
            <IconButton
              variant="text"
              className="rounded-full"
              color="blue"
              onClick={bulkReAttempt}
            >
              <GiCycle />
            </IconButton>
          </Tooltip>

          {/* <Tooltip content="Generate MetaData">
            <IconButton variant="text" className="rounded-full" color="blue" onClick={bulkGenerateMetaData}>
              <FaMagic />
            </IconButton>
          </Tooltip> */}
          <Tooltip content="train">
            <IconButton
              variant="text"
              className="rounded-full"
              color="blue"
              onClick={bulkTrain}
            >
              <FaCheckDouble />
            </IconButton>
          </Tooltip>
          <Tooltip content="private">
            <IconButton
              variant="text"
              className="rounded-full"
              color="blue"
              onClick={bulkPrivate}
            >
              <FaLock />
            </IconButton>
          </Tooltip>
          <Tooltip content="public">
            <IconButton
              variant="text"
              className="rounded-full"
              color="blue"
              onClick={bulkPublic}
            >
              <FaUnlock />
            </IconButton>
          </Tooltip>
          <Tooltip content="delete">
            <IconButton
              variant="text"
              className="rounded-full"
              color="red"
              onClick={bulkDelete}
            >
              <FaTrashAlt />
            </IconButton>
          </Tooltip>
        </>
      ) : (
        <>
          {selectedDocsApi !== "all" && (
            <>
              <Tooltip content="Re-attempt">
                <IconButton
                  variant="text"
                  className="rounded-full"
                  color="blue"
                  onClick={bulkReAttempt}
                >
                  <GiCycle />
                </IconButton>
              </Tooltip>
              <Tooltip content="delete">
                <IconButton
                  variant="text"
                  className="rounded-full"
                  color="red"
                  onClick={bulkDelete}
                >
                  <FaTrashAlt />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      )}
    </>
  );

  const onChangeCheckValues = (values) => {
    setCheckValues(values);
  };

  const onChangePagination = (cp, ps) => {
    setCurrentPage(cp);
    setPageSize(ps);

    queryClient.setQueryData("books-cp", cp);
    queryClient.setQueryData("books-ps", ps);
  };

  const onChangeFilter = (filterValues) => {
    setSelectedFilter(
      Object.keys(filterValues)[0] === undefined
        ? "name"
        : Object.keys(filterValues)[0]
    );
    setFilterValues(filterValues);
    queryClient.setQueryData("books-filters", { ...filterValues });
  };

  const onChangeSorter = (sorterValues) => {
    setSorterValues({ ...sorterValues });
    queryClient.setQueryData("books-sorters", { ...sorterValues });
  };

  const onSearchFileName = (data) => {
    let selectedFilterVar = selectedFilter;

    setFilterValues((vals) => {
      return {
        ...vals,
        [selectedFilterVar]: data.name,
      };
    });
  };

  const toogleOpenEditor = () => {
    if (editorOpen === true) {
      setContentId(null);
    }
    setEditorOpen(!editorOpen);
  };
  const toogleOpenLogs = () => {
    if (logsOpen === true) {
      setContentId(null);
    }
    setLogsOpen(!logsOpen);
  };
  const toogleOpenAppeal = () => {
    if (editorOpen === true) {
      setContentId(null);
    }
    setAppealOpen(!appealOpen);
  };
  // const toogleOpenView = () => {
  //   if (viewOpen === true) {
  //     setContentId(null);
  //   }
  //   setViewOpen(!viewOpen);
  // };

  const handleEdit = (id) => {
    setContentId(id);
    toogleOpenEditor();
  };

  const handleLogs = (id) => {
    setContentId(id);
    toogleOpenLogs();
  };

  const handleAppeal = (id) => {
    setContentId(id);
    toogleOpenAppeal();
  };

  // const handleView = id => {
  //   setContentId(id);
  //   toogleOpenView();
  // };

  const onChangeSelectedFilter = (val) => {
    setSelectedFilter(val);
  };

  useEffect(() => {
    setBooks([]);
    refetch({ cancelRefetch: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDocsApi]);

  const tableHeaders = [
    {
      key: "name",
      name: "name",
      // filter: {
      //   type: "search",
      // },
      sorter: true,
    },
    {
      key: "uploadedBy",
      name: " user",
      width: "30%",
      // filter: {
      //   type: "search",
      // },
      sorter: true,
    },
    {
      key: "status",
      name: "status",
      width: "20%",
      filter: {
        type: "check",
        kinds: [
          { name: "ready", value: "ready" },
          { name: "rejected", value: "rejected" },
          { name: "pending", value: "pending" },
          { name: "failed", value: "failed" },
          { name: "done", value: "done" },
          { name: "training_failed", value: "training_failed" },
        ],
      },
      sorter: false,
    },
    {
      key: "private",
      name: "private",
      width: "20%",
      // filter: {
      //   type: "radio",
      //   kinds: [
      //     { name: "private", value: 1 },
      //     { name: "public", value: 0 },
      //   ],
      // },
      sorter: true,
    },
    // { key: "updated_at", name: "modified", sorter: true },
    {
      key: "actions",
      name: "",
      // default: (id) => (
      //   <>
      //     {UserService.getRole()?.roles?.includes("admin") && (
      //       <Menu
      //         animate={{
      //           mount: { y: 0 },
      //           unmount: { y: 25 },
      //         }}
      //       >
      //         <MenuHandler>
      //           <Button>Action</Button>
      //         </MenuHandler>
      //         <MenuList>
      //           <MenuItem
      //             onClick={() => {
      //               handleForceTrain(id);
      //             }}
      //           >
      //             Force Train
      //           </MenuItem>
      //           <Menu
      //             placement="right-start"
      //             open={openMenu}
      //             handler={setOpenMenu}
      //             allowHover
      //             offset={15}
      //           >
      //             <MenuHandler className="flex items-center justify-between">
      //               <MenuItem>
      //                 Move
      //                 <ChevronUpIcon
      //                   strokeWidth={2.5}
      //                   className={`h-3.5 w-3.5 transition-transform ${
      //                     openMenu ? "rotate-90" : ""
      //                   }`}
      //                 />
      //               </MenuItem>
      //             </MenuHandler>
      //             <MenuList>
      //               <MenuItem
      //                 onClick={() => {
      //                   handleMove(id, "law");
      //                 }}
      //               >
      //                 Law Docs
      //               </MenuItem>
      //               <MenuItem
      //                 onClick={() => {
      //                   handleMove(id, "wisdom");
      //                 }}
      //               >
      //                 Wisdom Docs
      //               </MenuItem>
      //             </MenuList>
      //           </Menu>
      //           <MenuItem
      //             onClick={() => {
      //               deleteFunc(id);
      //             }}
      //           >
      //             Delete
      //           </MenuItem>
      //         </MenuList>
      //       </Menu>
      //     )}
      //   </>
      // ),
    },
  ];

  const onHandleSwitchChange = (val) => () => {
    setSelectedDocsApi(val ? "mine" : "all");
  };

  const deb = useCallback(
    debounce((text) => {
      setFilterValue(text);
    }, 500),
    []
  );

  const handleFilterChange = (e) => {
    deb(e.target.value);
  };

  return (
    <>
      <div className="my-5 mx-3">
        <div className="flex w-full justify-center py-2 pr-3">
          <form onSubmit={handleSubmit(onSearchFileName)}>
            <div className="flex">
              <div className="flex items-center gap-2 flex-col sm:flex-row">
                <div className="min-w-[120px] max-w-[120px]  first:[&>div]:sm:!min-w-[120px] first:[&>div]:min-w-auto">
                  <Select
                    label="Search by"
                    className="min-w-[100px] max-w-[120px]"
                    value={selectedFilter}
                    onChange={onChangeSelectedFilter}
                  >
                    <Option value="name">Name</Option>
                    <Option value="title">Title</Option>
                    <Option value="author">Author</Option>
                    <Option value="abstract">Abstract</Option>
                  </Select>
                </div>
                <Input
                  size="lg"
                  icon={
                    <MagnifyingGlassIcon
                      className="h-5 w-5 cursor-pointer"
                      onClick={() => refetch()}
                    />
                  }
                  placeholder="Search"
                  className=" !border !border-gray-300 bg-white text-gray-900 shadow-lg shadow-gray-900/5 ring-4 ring-transparent placeholder:text-gray-500 focus:!border-gray-900 focus:!border-t-gray-900 focus:ring-gray-900/10"
                  labelProps={{
                    className: "hidden",
                  }}
                  containerProps={{ className: "min-w-[400px]" }}
                  onChange={handleFilterChange}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="pt-4 px-3">
          {selectedDocsApi === "mine" && (
            <>
              <DocsStatus docType="scientific" />
              {/* <Container>
                <CardTitle className="h4">Submit Research document(s)</CardTitle>
                <ContributeDocs docType="scientific" />
              </Container> */}
            </>
          )}
        </div>
        <Table
          isFetching={isFetching}
          tableHeaders={tableHeaders}
          data={books}
          paginationPosition="both"
          pagination={{
            pageSizeKind: [
              { name: "50 items per page", value: 50 },
              { name: "100 items per page", value: 100 },
              { name: "150 items per page", value: 150 },
              { name: "200 items per page", value: 200 },
            ],
            totalPage: totalPage,
            currentPage: currentPage,
            pageSize: pageSize,
          }}
          actions={actions}
          onChangeCheckValues={onChangeCheckValues}
          checkData={checkValues}
          onChangePagination={onChangePagination}
          onChangeFilter={onChangeFilter}
          filters={filterValues}
          onChangeSorter={onChangeSorter}
          sorters={sorterValues}
        />
      </div>

      <EditMetaContent
        toogleOpenEditor={toogleOpenEditor}
        id={contentId}
        open={editorOpen}
      />

      <ViewLogsDoc
        docType="scientific"
        toogleOpenEditor={toogleOpenLogs}
        id={contentId}
        open={logsOpen}
      />
      <RequestAppeal
        docType="scientific"
        toogleOpenEditor={toogleOpenAppeal}
        id={contentId}
        open={appealOpen}
      />
      {/* <GenerateSummayQA toogleOpenEditor={toogleOpenView} id={contentId} open={viewOpen} /> */}
    </>
  );
};

export default AllScientificDocs;
